import type { FC } from 'react';

import SoundSettingItem from './components/SoundSettingItem';
import ContinuePlayingSettingItem from './components/ContinuePlayingSettingItem';
import { SeasonalBrandingSettingsItem } from './components/SeasonalBrandingSettingsItem';
import { useSeasonalBrandingSettings } from 'store/featureFlags/featureFlagsStore';
// TODO: uncomment useAppStore when continue playing is implemented to get from store (BE)
// import { useAppStore } from '../../../../store/app/appStore';

const SettingsTab: FC = () => {
  // TODO: get enableContinuePlaying from store when BE is ready
  // const enableContinuePlaying = useAppStore((state) => state.settings.enableContinuePlaying) ?? false;
  const enableContinuePlaying = true;
  const hasSeasonalBranding = useSeasonalBrandingSettings().hasBranding;
  
  return (
    <>
      {enableContinuePlaying && <ContinuePlayingSettingItem />}
      <SoundSettingItem />
      {hasSeasonalBranding && <SeasonalBrandingSettingsItem />}
    </>
  );
};

export default SettingsTab;
